module.exports = __webpack_public_path__ + "img/5.c5d4f6f5.jpeg";